import { Col, Row } from 'antd'
import React from 'react'
import { ContentInputField } from '../../../../../components/atoms/formFields/inputField/contentInputField'
import SelectOption from '../../../../../components/atoms/formFields/selectOption'

const CategoryDetail = ({productbase, detail}) => {
  return (
    <Row gutter={[12, 12]}>
      <Col xs={24}>
        <h6 className="font-weight-bolder">
          Product Category
        </h6>
      </Col>
      <Col xs={12} lg={8}>
        <ContentInputField
          value={detail?.productDetails?.productDomain
                ?.en}
          disabled={true}
          name="Domain Category"
        />
      </Col>
      <Col xs={12} lg={8}>
        <ContentInputField
          disabled={true}
          name="Parent Category"
        value={detail?.productDetails
              ?.productParentCategory?.en}
        />
      </Col>


      {productbase !== "SEEDS" ? (
        <Col xs={12} lg={8}>
          <SelectOption
            isDisabled={true}
            placeholder="Purpose of Use"
            isMulti
          value={detail?.productDetails?.concerns?.map(
            (concern, index) => {
              return {
                label: concern?.en,
                value: concern?.en,
              };
            }
          )}
          />
        </Col>
      ) : (
        <Col xs={12} lg={8}>
          <ContentInputField
            disabled={true}
            name="Crop"
            value={detail?.productDetails?.crop?.en}
          />
        </Col>
      )}
    </Row>
  )
}

export default CategoryDetail